var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { center: "", grow: "" } },
    [
      _c("w-col", { attrs: { center: "", grow: "" } }, [
        _c("div", { staticClass: "text-container" }, [
          _vm._v(" " + _vm._s(_vm.$ct("plan-request-successfull")) + " "),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }